import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// Components
import { CatalogProduct } from '@mobilitystore/components-interface';
import CustomizedSnackbars from '../../../components/Shared/Utils/SnackBar';

// Actions
import { regenerateAAATokens } from '../../../actions/LoginAction';

// Constants
import idConstants from '../../../data/idConstants';

// Utils
import { getEnvironment } from '../../../utils';

// CSS
import './index.scss';

const BulkProductDetailsContainer = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const initialSnackbarState = {
    status: '',
    show: false
  };

  const [snackbarStatus, setSnackbarStatus] = React.useState(initialSnackbarState);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleProductDetailsError = (error) => {
    setSnackbarStatus({
      status: 'error',
      message: error.message,
      show: true
    });

    if (error.error === 'ERR_NETWORK') {
      dispatch(regenerateAAATokens()).then(() => {
        window.location.reload();
      });
    }
  };

  return (
    <div>
      {snackbarStatus.show && (
        <CustomizedSnackbars
          severity={snackbarStatus.status}
          message={snackbarStatus.message}
          changeState={() => setSnackbarStatus(initialSnackbarState)}
        />
      )}
      <CatalogProduct
        className='bulk-product-details'
        productId={location.state.productId}
        token={localStorage.getItem(idConstants.tokens.aaaIdToken)}
        environment={getEnvironment(process.env.REACT_APP_ENVIRONMENT)}
        tenantId={process.env.REACT_APP_SELLER_TENANT_ID}
        onError={handleProductDetailsError}
        onCancel={() => history.goBack()}
      />
    </div>
  );
};

export default BulkProductDetailsContainer;
